module.exports = __webpack_public_path__ + "static/media/msgicon2.913b8504.webp";